import { staticPath } from "faqSrc/lib/$path";
import Link from "next/link";
import React from "react";
import styled from "styled-components";
import Image from "components/atoms/Image";
import { snsIconLabel } from "~/styles/CommonStyles";

type ButtonSize = "small" | "medium";
const heightMap: { [key in ButtonSize]: number } = {
  medium: 48,
  small: 40,
};
const iconSizeMap: { [key in ButtonSize]: number } = {
  medium: 28,
  small: 20,
};

interface TwitterButtonProps {
  label?: string;
  onClick?: () => void;
  showLabel?: boolean;
  size?: ButtonSize;
  twitterShareUrl?: string;
}

const TwitterButton: React.FC<TwitterButtonProps> = ({
  label = "ツイート",
  onClick,
  showLabel = true,
  size = "small",
  twitterShareUrl,
}) => {
  if (!twitterShareUrl && !onClick) {
    return <></>;
  }

  const twitterIcon = (
    <TwitterIcon
      aria-label="Twitter share link"
      rel="noreferrer noopener"
      target="_blank"
      title="Twitter share link"
      onClick={onClick}
    >
      <IconWrap dataSize={size}>
        <Image
          alt="Twitter share link"
          ampLayout="fixed"
          disableHover
          height={iconSizeMap[size]}
          layout="fixed"
          src={staticPath.img.sns.twitter_white_svg}
          width={iconSizeMap[size]}
        />
      </IconWrap>
      {showLabel && label && <IconLabel>{label}</IconLabel>}
    </TwitterIcon>
  );

  if (twitterShareUrl) {
    return (
      <Link href={twitterShareUrl} passHref locale={false}>
        {twitterIcon}
      </Link>
    );
  }

  return twitterIcon;
};

const TwitterIcon = styled.a`
  align-items: center;
  cursor: pointer;
  display: grid;
  gap: 6px;

  &:hover {
    opacity: 0.8;
  }
`;

const IconWrap = styled.div<{ dataSize: ButtonSize }>`
  align-items: center;
  background-color: #55aced;
  border-radius: 50%;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  display: grid;
  height: ${(props) => heightMap[props.dataSize]}px;
  justify-content: center;
  margin: 0 auto;
  overflow: hidden;
  width: ${(props) => heightMap[props.dataSize]}px;
`;

const IconLabel = styled.span`
  ${snsIconLabel};
`;

export default TwitterButton;
